import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'

import EventItemBase, * as EventItem from '@segment/matcha/recipes/EventItem'
import EventFlow from '@segment/matcha/recipes/EventFlow'

const events = [
  {
    label: `User Signup`,
    detail: `4s`,
  },
  {
    label: `Product Added`,
  },
  {
    label: `Order Completed`,
  },
  {
    label: `Push events to your favorite tools`,
  },
]

const Linkage: FC<PropsWithChildren<unknown>> = () => {
  const theme = useTheme()

  const eventItemTokens = { color: theme.palette.twilio.boysenberry[60] }

  return (
    <Inner>
      <EventFlow
        gradient={
          <>
            <stop stopColor={theme.palette.twilio.green[50]} stopOpacity="0" />
            <stop offset="0.48183" stopColor={theme.palette.twilio.green[50]} stopOpacity="0.5" />
            <stop offset="1" stopColor={theme.palette.twilio.green[50]} stopOpacity="0" />
          </>
        }
        gradientDots={
          <>
            <stop stopColor={theme.palette.neutrals.white[100]} stopOpacity="1" />
            <stop offset="0.489183" stopColor={theme.palette.neutrals.white[100]} stopOpacity="1" />
            <stop offset="1" stopColor={theme.palette.neutrals.white[100]} stopOpacity="1" />
          </>
        }
      >
        {events.slice(0, -1).map((event) => (
          <EventItemBase key={event.label} size="small" textAlign="center">
            <EventItem.Body>
              <EventItem.Code tokens={eventItemTokens}>{event.label}</EventItem.Code>
            </EventItem.Body>
            {event.detail && (
              <EventItem.Detail tokens={{ color: theme.palette.twilio.gray[40] }}>{event.detail}</EventItem.Detail>
            )}
          </EventItemBase>
        ))}

        <EventItemBase background={theme.palette.twilio.boysenberry[60]} elevation={2} size="small" textAlign="center">
          <EventItem.Body>
            <EventItem.Code tokens={{ color: theme.palette.neutrals.white[100] }}>
              {events.at(-1)?.label}
            </EventItem.Code>
          </EventItem.Body>
        </EventItemBase>
      </EventFlow>
    </Inner>
  )
}

const Inner = styled.div`
  min-width: min(100%, 340px);
  position: relative;
  min-height: 460px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: fit-content;
  margin: 0 auto;
`

export default Linkage
